"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* eslint-disable max-len */
// values in this file are never directly used in components but set the 'base theme' properties

/*
  These are the standard rootShadows that should be used in the theme file.
  it may be safe to pull directly from this file for specific components.
 */
var rootShadows = {
  shadow100: {
    category: 'shadow',
    commonUses: ['unused'],
    dataType: 'shadow',
    value: '0 2px 4px rgb(0, 0, 0, 0.4)'
  },
  shadow200: {
    category: 'shadow',
    commonUses: ['Bars (e.g. policy #)', 'cards'],
    dataType: 'shadow',
    value: '0 2px 8px rgb(0, 0, 0, 0.4)'
  },
  shadow200_active: {
    category: 'shadow',
    commonUses: ['Bars (e.g. policy #)', 'cards'],
    dataType: 'shadow',
    value: '0 3px 10px rgb(0, 0, 0, 0.43)'
  },
  shadow300: {
    category: 'shadow',
    commonUses: ['Dropdowns'],
    dataType: 'shadow',
    value: '0 2px 8px rgb(0, 0, 0, 0.45)'
  },
  shadow400: {
    category: 'shadow',
    commonUses: ['unused'],
    dataType: 'shadow',
    value: '0 2px 24px rgb(0, 0, 0, 0.5)' // todo: be sur to test this - it seems extreme

  },
  shadow500: {
    category: 'shadow',
    commonUses: ['unused'],
    dataType: 'shadow',
    value: undefined
  }
};
var _default = rootShadows;
exports.default = _default;